import { Card, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, CardContent, Stack } from "@mui/material";

import { type BookingStatsCardProps } from "./getBookingStatsCardProps";

export function NearbyBookingStatsCard(props: BookingStatsCardProps) {
  const { activityLabel, status, bodyMessage, footerMessage } = props;

  return (
    <Card
      sx={(theme) => ({
        borderRadius: theme.borderRadius?.medium,
        mx: 5,
      })}
    >
      <CardContent>
        <Stack spacing={3}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: (theme) => theme.palette[status].main,
                flexShrink: 0,
              }}
            />
            <Text semibold variant="body2">
              {activityLabel}
            </Text>
          </Stack>

          <Text variant="body2" color={(theme) => theme.palette.text.secondary}>
            {bodyMessage}
          </Text>

          {isDefined(footerMessage) && (
            <Text variant="caption" color={(theme) => theme.palette.text.secondary}>
              {footerMessage}
            </Text>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
